import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { UploadedFile } from 'web-library/models/UploadedFile';
import { useGetUploadedFileInfo } from '../../../api-refactored/group-special-consideration/useGetUploadedFileInfo';
import UploadSupportingDocumentsContent from './UploadSupportingDocumentsContent';
import { UploadedFileModel } from '../../../api-refactored/special-consideration/useGetUploadedFileInfo';

interface UploadCoordinatorSupportingDocumentsProps {
  routeSteps: { label: string }[];
  amendment: boolean;
}

const UploadCoordinatorSupportingDocuments = ({
  routeSteps,
  amendment,
}: UploadCoordinatorSupportingDocumentsProps) => {
  const { uuid } = useParams<{ uuid: string }>();

  const [files, setFiles] = useState<UploadedFile[]>([]);
  const [draftFiles, setDraftFiles] = useState<UploadedFile[]>([]);
  const [isFileLoaded, setIsFileLoaded] = useState(false);

  const { data: uploadedFileInfo } = useGetUploadedFileInfo({
    uuid,
    onSuccess: (data) => {
      const attachFiles = data
        .filter((item: UploadedFileModel) => !item.isSubmitted)
        .map((f) => {
          const newFile = new File([new ArrayBuffer(f.fileSizeInBytes)], f.fileName);
          return {
            file: newFile,
            hasError: false,
            pending: false,
            uploaded: true,
            key: f.fileUuid,
          };
        });
      setDraftFiles(attachFiles);
      setIsFileLoaded(true);
    },
  });

  return (
    <>
      {isFileLoaded && (
        <UploadSupportingDocumentsContent
          routeSteps={routeSteps}
          uploadedFileInfo={uploadedFileInfo}
          files={files}
          draftFiles={draftFiles}
          setFiles={setFiles}
          setDraftFiles={setDraftFiles}
          isGroup
          amendment={amendment}
        />
      )}
    </>
  );
};

export default UploadCoordinatorSupportingDocuments;
